import React from "react";


export default function Dropdown(props) {
  return <ul className="ds-dropdown">{props.children}</ul>
}


/*

Usage:

<Dropdown>
  <li></li>
</Dropdown>

*/
